// @flow
import { get } from "lodash";

const getById = (state: Object): Object => get(state, "leaguesClassic.by_id");

export default getById;